import { Component, OnInit, Renderer2, ViewChild, Inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router, Event, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Menu } from '../models/common';
import { CommonService } from '../services/common.service';
import { IstDataShareService } from '../services/ist/ist-datashare.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private unsubscriber: Subject<void> = new Subject<void>();
  app_ext: boolean = false;
  hasLoggedIn: boolean = false;
  message: string;
  routename: string;
  isShowWelcomeMessage: boolean;
  leftMenuItems: Menu[];
  routerLinkUrl:any;
  setQueryParams;
  constructor(
    private renderer: Renderer2,
    private summaryService: AdministrationSummaryService,
    private userDetails: UserService,
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute : ActivatedRoute,
    private commonService: CommonService,
    private dataShare: IstDataShareService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd) {
    //     if (location.href) {
    //       location.href.indexOf('application-ext') > -1 ? this.app_ext = true : this.app_ext = false;
    //       window['app_ext'] = this.app_ext;
    //     }
    //   }
    // });
    this.activatedRoute.queryParams.subscribe(params=>{
      this.setQueryParams = params;
      if(params && params.app_ext){
        this.app_ext = true;
        
      }else{
        this.app_ext = false;
      }
      window['app_ext']=this.app_ext;

      if (params) {
        let moduleUrl = '/home/' + params['module'] + '/' + params['screen_type'] + '/';
        let requestId = params['id'];
        let module = params['module'];
        this.routerLinkUrl = moduleUrl + 'application-ext/:' + requestId;

      }
    })
  }
  ngOnInit() {
    this.isShowWelcomeMessage = false;
    // if (location.href) {
    //   location.href.indexOf('application-ext') > -1 ? this.app_ext = true : this.app_ext = false;
    //   window['app_ext'] = this.app_ext;
    // }
    // this.modalService.activeInstances.subscribe((event) =>{
    //   this.renderer.addClass(this.document.getElementsByTagName('mdb-modal-container')[0], 'right');
    // });
    //if (this.router.url === '/home')
    //  this.isShowWelcomeMessage = true;
    //else
    //  this.isShowWelcomeMessage = false;

    this.userDetails.checkSession().subscribe((result) => {
      //this.setForm(result);
    });
    history.pushState(null, '');

    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, '');
        //this.showError = true;
      });
      this.dataShare.LeftMenu.subscribe(x => {
        this.leftMenuItems=x;
      });
  }


  // closeToggle() {
  //   this.renderer.removeClass(this.appHeader['sidenav'].el.nativeElement.firstElementChild, 'side-nav-extended');
  //   this.renderer.addClass(this.appHeader['sidenav'].el.nativeElement.firstElementChild, 'side-nav-closed');
  // }
  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
